import React from 'react';

interface Platform {
  name: string;
  logo: string;
  width?: string;
  height?: string;
}

export function Platforms() {
  const platforms: Platform[] = [
    {
      name: 'Wix',
      logo: 'https://logos-world.net/wp-content/uploads/2020/10/Wix-Logo.png',
      width: 'w-[200px]',
      height: 'h-[100px]'
    },
    {
      name: 'Readymag',
      logo: 'https://dt2sdf0db8zob.cloudfront.net/wp-content/uploads/2018/05/readymag-Logo.png',
      width: 'w-[500px]',
      height: 'h-[80px]'
    },
    {
      name: 'Squarespace',
      logo: 'https://logos-world.net/wp-content/uploads/2021/02/Squarespace-Logo-2018-present.png',
      width: 'w-[350px]',
      height: 'h-[130px]'
    },
    {
      name: 'Shopify',
      logo: 'https://logos-world.net/wp-content/uploads/2020/11/Shopify-Logo.png',
      width: 'w-[300px]',
      height: 'h-[110px]'
    }
  ];
  
  return (
    <section className="py-16 px-4">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-3xl font-bold text-center mb-16">
          Perfect to use on:
        </h2>
        <div className="flex justify-center items-center gap-8 flex-wrap">
          {platforms.map((platform) => (
            <div 
              key={platform.name} 
              className={`grayscale hover:grayscale-0 transition-all duration-400 ${platform.width} ${platform.height} flex items-center justify-center`}
            >
              <img
                src={platform.logo}
                alt={`${platform.name} logo`}
                className="w-full h-full object-contain px-4"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}